<link href="https://unpkg.com/survey-angular@1.8.77/modern.css" type="text/css" rel="stylesheet" />
<script src="https://unpkg.com/survey-angular@1.8.77/survey.angular.min.js"></script>

<div id="surveyElement"></div>